import {inject} from "@angular/core";
import {CanActivateFn} from "@angular/router";
import {map, of, take} from "rxjs";
import {Userrole} from "../../shared/interfaces/user";
import {UserService} from "../../services/user.service";

export const userroleGuard: CanActivateFn = (route, state) => {
  const userService = inject(UserService);
  const userroleType = Userrole
  const allowedUserRoles = [
    userroleType.Techniker,
    userroleType.Produktionsleiter,
    userroleType.Teamleiter,
    userroleType.Schichtleiter,
  ];
  return of(userService.user()?.app_metadata['userrole']).pipe(
    take(1),
    map((userrole: Userrole) => {
      return allowedUserRoles.includes(userrole);
    })
  );
};
